import React, { useContext, useEffect, useState } from "react";
import { createEstructuraLogsUbicaciones, estructuraNivel1, estructuraLogsUbicacion, createEstructuraNivel1 } from "../../utils/estructuras";

import './UbicacionesSubtabla.css';
import RRLogsUbicaciones from "../renderRows/RRLogsUbicaciones";
import FormNivel3 from "../FormNivel3/FormNivel3";
import FormNivel2 from "../FormNivel2/FormNivel2";
import FormNivel1 from "../FormNivel1/FormNivel1";
import DictionaryText from "../dictionaryText/DictionaryText";
import authContext from "../../context/authentication/authContex";

const UbicacionesSubtabla = ({tablaSeleccionada, logsUbicaciones, handleChenge, usuario, opcionesUsers, modo, nivel1Lista, nivel2List, nivel3List, nivel4List, nivel5List}) =>{

    const [opciones,setOpciones] = useState([]);
    const {getValorActualFromDictionary} = useContext(authContext);

    const createOptions = () =>{
        let opcionesModeladas = [];
        let opcionesNivel1s = nivel1Lista.map((dato) =>({ name: dato.name, value: dato.codNivel1, label: dato.name, id: dato._id, codNivel1: dato.codNivel1, descrp: dato.descrp, direccion: dato.direccion, lat: dato.lat, lng: dato.lng}));
        logsUbicaciones.forEach((l,i)=>{
            
            let opcionesNivel2s = nivel2List?.filter(nivel2 => nivel2.nivel2Nivel1ID === l.nivel1.id).map(nivel2 => ({name: nivel2.name, value: nivel2.codNivel2, label: nivel2.name, id: nivel2._id, codNivel2: nivel2.codNivel2, descrp: nivel2.descrp, direccion: nivel2.direccion, lat: nivel2.lat, lng: nivel2.lng }));
            opcionesNivel2s.unshift({label:`Sin ${getValorActualFromDictionary("Nivel 2")}`, value:''});
            
            let opcionesNivel3s = nivel3List?.filter(nivel3 => nivel3.nivel3Nivel2ID === l.nivel2.id).map(nivel3 => ({nameNivel3: nivel3.nameNivel3, value: nivel3.codNivel3, label: nivel3.nameNivel3, id: nivel3._id, codNivel3: nivel3.codNivel3, descrp: nivel3.descrp, nivel3Nivel2ID: nivel3.nivel3Nivel2ID, codNivel2: nivel3.codNivel2, direccion: nivel3.direccion, lat: nivel3.lat, lng: nivel3.lng }));
            opcionesNivel3s.unshift({label:`Sin ${getValorActualFromDictionary("Nivel 3")}`, value:''});

            let opcionesNivel4s = nivel4List?.filter(nivel4 => nivel4.nivel4Nivel3ID === l.nivel3?.id).map(nivel4 => ({name: nivel4.name, value: nivel4.codNivel4, label: nivel4.name, id: nivel4._id, codNivel4: nivel4.codNivel4, descrp: nivel4.descrp, direccion: nivel4.direccion, lat: nivel4.lat, lng: nivel4.lng }));
            opcionesNivel4s.unshift({label:`Sin ${getValorActualFromDictionary("Nivel 4")}`, value:''});

            let opcionesNivel5s = nivel5List?.filter(nivel5 => nivel5.nivel5Nivel4ID === l.nivel4?.id).map(nivel5 => ({name: nivel5.name, value: nivel5.codNivel5, label: nivel5.name, id: nivel5._id, codNivel5: nivel5.codNivel5, descrp: nivel5.descrp, direccion: nivel5.direccion, lat: nivel5.lat, lng: nivel5.lng }));
            opcionesNivel5s.unshift({label:`Sin ${getValorActualFromDictionary("Nivel 5")}`, value:''});

            opcionesModeladas.push({opcionesNivel1s, opcionesNivel2s, opcionesNivel3s, opcionesNivel4s, opcionesNivel5s});
        })
        setOpciones(opcionesModeladas);
    }

    const handleChange = (l = {}, i, prop='', value=undefined) => {
        let logsUpdated = logsUbicaciones.slice();
  
        if(prop != '' && value != undefined && Object.keys(l).length == 0){
            logsUpdated[i][prop] = value;
            switch(prop){
                case 'nivel1': {
                    logsUpdated[i].nivel2 = {...createEstructuraNivel1()};
                    logsUpdated[i].nivel3 = {...createEstructuraNivel1()};
                    logsUpdated[i].nivel4 = {...createEstructuraNivel1()};
                    logsUpdated[i].nivel5 = {...createEstructuraNivel1()};
                    if(logsUpdated[logsUpdated.length-1].nivel1.value != '') logsUpdated.push({...createEstructuraLogsUbicaciones(), user: {userName: usuario.userName, label: usuario.userName, value: usuario.userName, comUserID: usuario._id}});
                    createOptions();
                    break;
                }
                case 'nivel2': {
                    logsUpdated[i].nivel3 = {...createEstructuraNivel1()};
                    logsUpdated[i].nivel4 = {...createEstructuraNivel1()};
                    logsUpdated[i].nivel5 = {...createEstructuraNivel1()};
                    createOptions();
                    break;
                }
                case 'nivel3': {
                    logsUpdated[i].nivel4 = {...createEstructuraNivel1()};
                    logsUpdated[i].nivel5 = {...createEstructuraNivel1()};
                    createOptions();
                    break;
                }
                case 'nivel4': {
                    logsUpdated[i].nivel5 = {...createEstructuraNivel1()};
                    createOptions();
                    break;
                }
            }
            handleChenge({},'logsUbicaciones',logsUpdated);                         
        }
    }

    const handleDelete = (log, index) => {
        let actualLogs = logsUbicaciones.slice();
        if(log.nivel1.value != ''){
            let logsToUpdate = actualLogs.filter((p,i) => i != index);
            handleChenge({},'logsUbicaciones',logsToUpdate);                         
        }
    }

    useEffect(()=>{
        createOptions();
    },[logsUbicaciones.length, nivel1Lista, nivel2List, nivel3List, nivel4List, nivel5List]);
    
    return <div className={`${(tablaSeleccionada != 'ubicaciones') && 'inactive'} fueraServicioSubtablaDiv ubicacionesSubtabla`}>
        <label>Ubicaciones</label>
        <div className="bodyTable">
            {logsUbicaciones.map((l,i) => <RRLogsUbicaciones log={l} i={i} nivel1Lista={nivel1Lista} nivel2List={nivel2List} nivel3List={nivel3List} nivel4List={nivel4List} nivel5List={nivel5List} modo={modo} opciones={opciones} usuario={usuario} handleChange={handleChange} handleDelete={handleDelete}  opcionesUsers={opcionesUsers}/>)}
        </div>
        
    </div>
}

export default React.memo(UbicacionesSubtabla);